export const sharedEnvironmentProd = {
  production: true,
  name: 'Production',
  showEnvironment: false,
  cookieDomain: '.vinnova.se',

  //Endpoints
  portalAdminUrl: 'https://e-admin.vinnova.se/adminportal',
  nJobEngineUrl: 'https://e-admin.vinnova.se/njobengine',
  notifyServiceApiUrl: 'https://notifiering.api.vinnova.se',
  eadminUrl: 'https://e-admin.vinnova.se',
  sprakHanteringApiUrl: 'https://sprakresurser.api.vinnova.se/api',
  bedomarpoolAdminUrl: 'https://bedomarpooladmin.vinnova.se',
  oregApiUrl: 'https://organisationsregistret.api.vinnova.se/api',
  bpoolApiUrl: 'https://bedomarpooladmin.api.vinnova.se',
  effektaUrl: 'https://effekta.vinnova.se',
  formBuilderApiUrl: 'https://formularbyggare.api.vinnova.se',
  formBuilderUrl: 'https://formularbyggare.vinnova.se',
  formAdmin: 'https://formularadmin.api.vinnova.se',
  etjansterCommonApiUrl: 'https://etjanster.api.vinnova.se',
  etjansterCommonUrl: 'https://etjanster.vinnova.se',
  bpUrl: 'https://bedomningsportal.vinnova.se',
  bpApiUrl: 'https://bedomningsportal.api.vinnova.se/api',
  enkatRegisterUrl: 'https://projekt.vinnova.se/enkatregister',
  oregUrl: 'https://projekt.vinnova.se/oreg',
  healthMonitorApiUrl: 'https://monitorering.api.vinnova.se',
  ansokanApiUrl: 'https://ansok.api.vinnova.se',
  ansokanUrl: 'https://ansok.vinnova.se',
  forhandsgranskaApiUrl: 'https://forhandsgranska.api.vinnova.se/api',
  forhandsgranskaUrl: 'https://forhandsgranska.vinnova.se',
  utlysningsbyggareApiUrl: 'https://utlysningsbyggare.api.vinnova.se/api',
  utlysningsbyggareUrl: 'https://utlysningsbyggare.vinnova.se',
  projektUrl: 'https://projekt.vinnova.se',
  logServiceApiUrl: 'https://loggservice.api.vinnova.se',
  gatewayUrl: 'https://api.vinnova.se',
  signeringApiUrl: 'https://signering.api.vinnova.se/api',

  apimSubscriptionKey: '3543fd9be0b3477089578aa5e394801d',

  // Keys
  tinyMceApiKey: '3v8orrp96m8v7vwbg61c31rrhu3dffg5wi6rlluihkl56ot0',

  //ClientIds
  azureAd: {
    formBuilderClientId: '0e3ad57e-1254-4695-a993-92dcca132edd',
    formBuilderApiClientId: '19aeaa07-6761-4c59-9d15-77947626c768',
    formAdminApiClientId: '437bfa68-cfc6-472c-8452-dff5ff8ade06',
    etjansterCommonApiClientId: '2ab1d012-5736-48ac-a84b-1f0ff2b3a0d5',
    etjansterCommonApiScope: 'api://2ab1d012-5736-48ac-a84b-1f0ff2b3a0d5/all',
  },
  azureAdB2C: {
    tenant: 'vinnovab2c',
    authority: 'https://vinnovab2c.b2clogin.com/vinnovab2c.onmicrosoft.com/',
    policies: {
      signUp: {
        name: 'B2C_1A_signup',
        authority:
          'https://vinnovab2c.b2clogin.com/vinnovab2c.onmicrosoft.com/b2c_1A_signup',
      },
      sso: {
        name: 'B2C_1_signupsignin_sso',
        authority:
          'https://vinnovab2c.b2clogin.com/vinnovab2c.onmicrosoft.com/b2c_1_signupandsignin_sso',
      },
      signInPhone: {
        name: 'B2C_1A_signin_phone',
        authority:
          'https://vinnovab2c.b2clogin.com/vinnovab2c.onmicrosoft.com/b2c_1A_signin_phone',
      },
      profileEdit: {
        name: 'B2C_1_profileedit',
        authority:
          'https://vinnovab2c.b2clogin.com/vinnovab2c.onmicrosoft.com/b2c_1_profileedit',
      },
      passwordChange: {
        name: 'B2C_1A_profile_edit_password_change',
        authority:
          'https://vinnovab2c.b2clogin.com/vinnovab2c.onmicrosoft.com/b2c_1a_profile_edit_password_change',
      },
      changeSignInName: {
        name: 'B2C_1A_changesigninname',
        authority:
          'https://vinnovab2c.b2clogin.com/vinnovab2c.onmicrosoft.com/b2c_1a_changesigninname',
      },
      // Behövs för att man ska kunna bygga projekt
      signIn: {
        name: '',
        authority: '',
      },
    },
    clientId: {
      etjansterCommonClientId: '609f23e4-4aba-4ffb-83ca-4e6d7b5a641c',
      etjansterCommonApiClientId: '19e6e554-171e-4e82-a836-7d303046c1f2',
      ansokanClientId: '582823ca-aa8c-4191-b94a-9624cbacd001',
      ansokanApiClientId: '072cc780-092b-4e99-b200-af47285d1ca9',
      bedomningsportalClientId: '66264396-849d-4c02-a705-37c5ced23f61',
      bedomningsportalApiClientId: 'afb16cd1-af48-4c79-8302-0ffda7fc7b68',
      projektClientId: 'cb1b3694-ff50-4211-932c-88448ca9e887',
      projektApiClientId: '11dfaaed-2f9a-4ddb-aeb0-fa3ecbce96ea',
      forhandsgranskaClientId: '98175dbb-cd47-49d4-9fcf-c49a299eeabe',
      forhandsgranskaApiClientId: '1c91d7c9-c45d-472b-aa4f-586dacbde0c9',
      enkatregisterApiClientId: 'f7386ef0-0f24-4bae-8a0e-2d0e2fb3bca1',
      oregApiClientId: 'e1e01ef8-6d06-484c-b524-bce00bb43df6',
      signeraApiClientId: 'afd90fbc-fd42-4567-9f9e-4aecdbb47217',
    },
  },
  //Externa länkar
  externalLinks: {
    ansokanGuide: {
      sv: 'https://www.vinnova.se/sok-finansiering/sa-har-fyller-du-i-ansokan/',
      en: 'https://www.vinnova.se/en/apply-for-funding/how-to-complete-your-application/',
    },
    regler: {
      sv: 'https://www.vinnova.se/sok-finansiering/regler-for-finansiering/',
      en: 'https://www.vinnova.se/en/apply-for-funding/rules-for-our-funding/',
    },
    gdpr: {
      sv: 'https://www.vinnova.se/om-oss/vart-uppdrag/regler-som-styr-var-verksamhet/personuppgifter/',
      en: 'https://www.vinnova.se/en/about-us/our-mission/rules-that-govern-our-activities/how-we-handle-personal-data/',
    },
  },
  ga4MeasurementId: 'G-KYJZZ9K7NG',
};
